/**
 * Phase 3 — Índice de traducciones
 * Delega al loader dinámico i18n/loader.js.
 * Cache compartido vía loader.
 */
import {
  loadTranslations as loadFromLoader,
  getTranslationsSync as getSyncFromLoader,
  clearTranslationsCache as clearFromLoader,
  invalidateCache as invalidateFromLoader,
  getCachedLanguages
} from '../../i18n/loader.js';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../../i18n/supportedLanguages.js';

export const loadTranslations = async (lang) => {
  const result = await loadFromLoader(lang);
  if (typeof window !== 'undefined') {
    const debugEnabled = import.meta.env.DEV || localStorage.getItem('archat_i18n_debug') === '1';
    if (debugEnabled) {
      console.log('[TRANSLATIONS]', getCachedLanguages());
    }
  }
  return result;
};
export const getTranslationsSync = getSyncFromLoader;
export const clearTranslationsCache = clearFromLoader;
export const invalidateCache = invalidateFromLoader;

export const reloadTranslations = async (lang) => {
  invalidateFromLoader(lang);
  return loadFromLoader(lang);
};

/** @param {string} lang @param {string} key */
export const hasTranslation = (lang, key) => {
  const t = getSyncFromLoader(lang);
  return t && t.hasOwnProperty(key);
};

/** @param {string} lang */
export const getAvailableKeys = (lang) => {
  const t = getSyncFromLoader(lang);
  return t ? Object.keys(t) : [];
};

/** @param {string} lang */
export const preloadTranslations = async (lang) => {
  const t = getSyncFromLoader(lang);
  if (!t || Object.keys(t).length === 0) {
    await loadFromLoader(lang);
  }
};

/**
 * Fallback global sin LanguageContext. Usa caché del loader.
 */
export const t = (key, currentLanguage = DEFAULT_LANGUAGE, fallback = '') => {
  const lang = (currentLanguage || DEFAULT_LANGUAGE).toLowerCase();
  const byLang = getSyncFromLoader(lang);
  if (byLang && byLang[key]) return byLang[key];
  const byEn = getSyncFromLoader('en');
  if (byEn && byEn[key]) return byEn[key];
  const byDefault = getSyncFromLoader(DEFAULT_LANGUAGE);
  if (byDefault && byDefault[key]) return byDefault[key];
  if (typeof fallback === 'string' && fallback.trim() !== '') return fallback;
  return key;
};
